module.exports = "<!-- <header class=\"logo\">\n  <img src=\"./assets/img/logo_black.png\" alt=\"LOGO\" />\n</header> -->\n"